import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../containers/User/AuthSlice';
import articleReducer from '../containers/Articles/ArticleSlice';
import articleTypeReducer from '../containers/Articles/ArticleTypeSlice';
import legalReducer from '../containers/Legal/LegalSlice';
import pageReducer from '../containers/Pages/PageSlice';
import subscriberReducer from '../containers/Subscribers/SubscriberSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        articles: articleReducer,
        articleTypes: articleTypeReducer,
        legal: legalReducer,
        pages: pageReducer,
        subscribers: subscriberReducer,
    },
});
